import type { FPlusLibraryScopeOuput } from '@festina/configuration-general-types/configuration'

import { useFPlusScopeFilterValue } from '../../context/fPlusScopeFilterValueContext'
import { ConfigurationItemIcon } from '../configurationItemIcon/ConfigurationItemIcon'
import { FPlusDefaultLibrary } from './FPlusDefaultLibrary'
import { HoverMenuList } from './HoverMenuList'

type FPlusDefaultLibraryListProps = {
  defaultLibraries: FPlusLibraryScopeOuput[]
}

export const FPlusDefaultLibraryList = ({
  defaultLibraries,
}: FPlusDefaultLibraryListProps) => {
  const { filterValue } = useFPlusScopeFilterValue()

  return (
    <HoverMenuList
      filterValue={filterValue}
      elements={defaultLibraries}
      renderLabel={(library) => (
        <div className="flex grow justify-start gap-x-2 text-base">
          <ConfigurationItemIcon type="library" />
          {library.libraryName}
        </div>
      )}
      renderHover={(library) => <FPlusDefaultLibrary library={library} />}
    />
  )
}
